module.exports = __webpack_public_path__ + "static/media/img3.bb78482a.jpg";